/**
 * Tipografía del bordado — Acacia Home
 * Aplica la fuente elegida y armoniza el campo con el estilo del tema.
 * Guardar como: assets/embroidery-font.js
 */
(function () {
  'use strict';

  /* Si el producto está en una colección excluida (bandera puesta por el
     bloque Liquid), escondemos por completo los campos de Textbox
     (iniciales + dibujo) y los sacamos del envío del formulario. */
  /* Hay dos motivos para esconder el bordado:
       1. Colección excluida (madera/cerámica/mármol) — bandera del bloque
          Liquid, permanente mientras dure la página.
       2. El cliente eligió la tarjeta "Sin bordar" — bandera que pone
          embroidery-options.js en <body>, y que puede revertirse.
     Por eso esta función va en los dos sentidos. */
  function hiddenByCollection() {
    return !!document.querySelector('[data-hide-bordado="true"]');
  }

  function hiddenByChoice() {
    return !!document.body &&
           document.body.getAttribute('data-emb-none') === 'true';
  }

  function textboxRoots() {
    // Puede haber más de uno: el sticky add-to-cart duplica el formulario
    return Array.prototype.slice.call(
      document.querySelectorAll('#textfieldapp, .textbox_fields')
    );
  }

  function hideTextbox() {
    var off = hiddenByCollection() || hiddenByChoice();

    textboxRoots().forEach(function (root) {
      var already = root.style.getPropertyValue('display') === 'none';

      if (off && !already) {
        root.style.setProperty('display', 'none', 'important');
      } else if (!off && already) {
        root.style.removeProperty('display');
      }

      var fields = root.querySelectorAll('input, textarea, select');
      for (var i = 0; i < fields.length; i++) {
        var f = fields[i];
        if (off) {
          // Un campo disabled no se envía al pedido.
          // Marcamos los que apagamos nosotros para no reactivar otros.
          if (!f.disabled) {
            f.disabled = true;
            f.setAttribute('data-emb-disabled', 'true');
          }
        } else if (f.getAttribute('data-emb-disabled') === 'true') {
          f.disabled = false;
          f.removeAttribute('data-emb-disabled');
        }
      }
    });
  }

  var RETRY_MS = 200;
  var MAX_TRIES = 50;

  function buildSelector(target) {
    if (target) {
      return (
        'input[name="properties[' + target + ']"], ' +
        'textarea[name="properties[' + target + ']"]'
      );
    }
    // Sin target explícito: excluir el campo de subida de archivo,
    // que también es un campo de Textbox pero no debe estilizarse.
    return (
      'input[name^="properties["]:not([type="file"]), ' +
      'textarea[name^="properties["]'
    );
  }

  function findInputs(select) {
    var target = (select.dataset.target || '').trim();
    var expected = target ? 'properties[' + target + ']' : null;

    // Buscamos por name Y por data-name, porque Textbox usa data-name
    // (que ya incluye el prefijo "properties[...]").
    var all = document.querySelectorAll(
      'textarea[data-tb-app-fields], input[data-tb-app-fields], ' +
      'textarea[name^="properties["], input[name^="properties["]'
    );

    var out = [];
    var seen = [];

    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.type === 'file') continue;
      if (seen.indexOf(el) !== -1) continue;

      var nm = el.getAttribute('name') || '';
      var dn = el.getAttribute('data-name') || '';

      if (expected) {
        // Coincidencia exacta contra el campo de iniciales
        if (nm !== expected && dn !== expected) continue;
      } else {
        // Sin target: solo campos con nombre real (descarta el de archivo, que es null)
        if (!nm && !dn) continue;
      }

      seen.push(el);
      out.push(el);
    }
    return out;
  }

  function currentFamily(select) {
    var option = select.options[select.selectedIndex];
    return option ? option.getAttribute('data-font') : null;
  }

  /* Neutraliza los estilos en línea de la app para que el campo
     herede la apariencia del tema. */
  function harmonize(input, opts) {
    var set = function (prop, value) {
      input.style.setProperty(prop, value, 'important');
    };

    // El atributo cols fija el ancho del textarea al margen del CSS
    if (input.hasAttribute('cols')) input.removeAttribute('cols');
    if (input.hasAttribute('size')) input.removeAttribute('size');

    set('width', '100%');
    set('display', 'block');
    set('max-width', '100%');
    set('min-width', '0');
    set('box-sizing', 'border-box');
    set('resize', 'none');
    set('white-space', 'normal');
    set('overflow', 'hidden');
    set('background', 'transparent');
    set('color', 'var(--color-input-text, currentColor)');
    set('border', 'var(--style-border-width-inputs, 1px) solid var(--color-input-border, #ccc)');
    set('border-radius', 'var(--style-border-radius-inputs, 0)');
    set('box-shadow', 'none');

    if (opts.center) set('text-align', 'center');

    // Un textarea alinea el texto arriba. Calculamos el padding
    // vertical para que quede ópticamente centrado en la caja.
    var lineHeight = opts.size ? opts.size * 1.4 : 20;
    var padY = 14;

    if (opts.minHeight) {
      set('min-height', opts.minHeight + 'px');
      padY = Math.max(10, Math.round((opts.minHeight - lineHeight) / 2));
    }

    set('padding', padY + 'px 16px');
  }

  /* El único problema real: .textbox_fields es flex column con
     align-items: flex-start, lo que impide que el campo se estire.
     Solo tocamos elementos DENTRO del contenedor de la app para no
     alterar el layout del tema. */
  function relaxAncestors(input) {
    var appRoot =
      input.closest('#textfieldapp') ||
      input.closest('.textbox_fields') ||
      null;

    if (!appRoot) return;

    var node = input.parentElement;
    var guard = 0;

    while (node && guard < 8) {
      var cs = window.getComputedStyle(node);

      if (cs.display === 'flex' || cs.display === 'inline-flex') {
        node.style.setProperty('align-items', 'stretch', 'important');
      }

      // Seguro dentro del contenedor de la app: no toca el layout del tema
      node.style.setProperty('width', '100%', 'important');
      node.style.setProperty('max-width', '100%', 'important');
      node.style.setProperty('min-width', '0', 'important');
      node.style.setProperty('align-self', 'stretch', 'important');
      node.style.setProperty('box-sizing', 'border-box', 'important');

      if (node === appRoot) break;

      node = node.parentElement;
      guard++;

      if (!node || (node !== appRoot && !appRoot.contains(node))) break;
    }
  }

  /* Copia la tipografía de nuestra etiqueta a la que pone la app,
     para que ambas se vean idénticas. */
  function matchLabel(input, reference) {
    if (!reference) return;

    var labels = [];

    // Textbox renderiza la etiqueta como <p data-fieldname="...">
    var raw = input.getAttribute('data-name') || input.getAttribute('name') || '';
    var fieldname = raw.replace(/^properties\[/, '').replace(/\]$/, '');

    if (fieldname) {
      labels = Array.prototype.slice.call(
        document.querySelectorAll('[data-fieldname="' + fieldname + '"]')
      );
    }

    if (!labels.length && input.labels && input.labels.length) {
      labels = Array.prototype.slice.call(input.labels);
    }

    var ref = window.getComputedStyle(reference);
    var props = [
      'font-family',
      'font-size',
      'font-weight',
      'font-style',
      'line-height',
      'letter-spacing',
      'text-transform',
      'color'
    ];

    labels.forEach(function (el) {
      props.forEach(function (prop) {
        el.style.setProperty(prop, ref.getPropertyValue(prop), 'important');
      });
      el.style.setProperty('max-width', '100%', 'important');
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('margin-block-end', '8px', 'important');
    });
  }

  /* El placeholder no se puede tocar con estilos en línea. */
  function injectPlaceholderRule(family) {
    var id = 'bordado-placeholder-style';
    var style = document.getElementById(id);
    if (!style) {
      style = document.createElement('style');
      style.id = id;
      document.head.appendChild(style);
    }
    var ff = family ? '"' + family + '"' : 'inherit';
    style.textContent =
      '[data-tb-app-fields]::placeholder{font-family:' + ff + ' !important;opacity:.35 !important;}';
  }

  /* El atributo form= no siempre reconecta el select al formulario en
     temas con checkout dinámico. Para asegurar que la tipografía llegue
     al pedido, replicamos su valor en un input oculto dentro del MISMO
     formulario donde vive el campo de iniciales (que sí llega al pedido). */
  function syncHidden(select, input) {
    var form = input.form || input.closest('form');
    if (!form) return;

    var key = select.getAttribute('name'); // properties[Tipografía]
    var hidden = form.querySelector('input[type="hidden"][name="' + key + '"][data-bordado-hidden]');

    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = key;
      hidden.setAttribute('data-bordado-hidden', 'true');
      form.appendChild(hidden);
      // El select ya no necesita enviar su valor: lo hace el hidden
      select.removeAttribute('name');
    }

    hidden.value = select.value;
  }

  /* Armoniza cualquier etiqueta de Textbox (Iniciales, Archivo, etc.)
     con la tipografía del tema, usando nuestra etiqueta como referencia. */
  function harmonizeAppLabels(reference) {
    if (!reference) return;
    var ref = window.getComputedStyle(reference);
    var props = ['font-family','font-size','font-weight','font-style','line-height','letter-spacing','text-transform','color'];

    var labels = document.querySelectorAll('[data-fieldname], .textbox_fields p, .textbox_fields label');
    for (var i = 0; i < labels.length; i++) {
      var el = labels[i];
      // No tocar nuestra propia etiqueta
      if (el.classList && el.classList.contains('embroidery-font__label')) continue;
      for (var j = 0; j < props.length; j++) {
        el.style.setProperty(props[j], ref.getPropertyValue(props[j]), 'important');
      }
      el.style.setProperty('max-width', '100%', 'important');
    }
  }

  function apply(select, quiet) {
    var inputs = findInputs(select);
    var family = currentFamily(select);
    if (!inputs.length || !family) return false;

    var size = parseInt(select.dataset.size, 10);
    var opts = {
      center: select.dataset.center === 'true',
      size: parseInt(select.dataset.size, 10) || 0,
      minHeight: parseInt(select.dataset.rows, 10) || 0
    };

    var wrapper = select.closest('.embroidery-font');
    var reference = wrapper ? wrapper.querySelector('.embroidery-font__label') : null;

    if (select.dataset.restyle !== 'false') harmonizeAppLabels(reference);

    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];

      syncHidden(select, input);

      if (select.dataset.restyle !== 'false') {
        harmonize(input, opts);
        relaxAncestors(input);
        matchLabel(input, reference);
        injectPlaceholderRule(family);
      }

      input.style.setProperty('font-family', '"' + family + '"', 'important');

      if (size) {
        input.style.setProperty('font-size', size + 'px', 'important');
        input.style.setProperty('line-height', '1.4', 'important');
        input.style.setProperty('height', 'auto', 'important');
      }
    }

    if (!quiet) console.log('[bordado] ->', select.value, '(' + family + ') | campos:', inputs.length);
    return true;
  }

  function attach(select, tries) {
    if (apply(select)) return;
    if (tries < MAX_TRIES) {
      window.setTimeout(function () { attach(select, tries + 1); }, RETRY_MS);
    } else {
      console.warn('[bordado] No se encontró el campo:', buildSelector(select.dataset.target));
    }
  }

  /* Textbox re-renderiza su bloque completo (sobre todo al haber varios
     campos), reemplazando los elementos y borrando nuestros estilos.
     Observamos el contenedor de la app y reaplicamos ante cualquier cambio,
     con un pequeño debounce para no entrar en bucle. */
  function watch(select) {
    if (!window.MutationObserver) return;
    if (select.bordadoWatching) return;
    select.bordadoWatching = true;

    var appRoot =
      document.getElementById('textfieldapp') ||
      document.querySelector('.textbox_fields');
    if (!appRoot) return;

    var pending = false;
    var observer = new MutationObserver(function () {
      if (select.bordadoApplying || pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        select.bordadoApplying = true;
        apply(select, true);
        window.requestAnimationFrame(function () {
          select.bordadoApplying = false;
          pending = false;
        });
      });
    });

    observer.observe(appRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  }

  function init(select) {
    if (select.dataset.wired === 'true') return;
    select.dataset.wired = 'true';

    select.addEventListener('change', function () { apply(select); });
    attach(select, 0);

    // Reintento tardío por si la app termina de montar después
    window.setTimeout(function () { apply(select); watch(select); }, 1200);
  }

  function scan() {
    hideTextbox();
    var list = document.querySelectorAll('[data-font-select]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  if (window.MutationObserver && document.body) {
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });

    /* El observer de arriba solo mira childList, así que un cambio de
       atributo en <body> no lo despierta. Cuando el cliente elige
       "Sin bordar", embroidery-options.js cambia data-emb-none: hay que
       reaccionar en ese momento, no esperar al siguiente re-render de
       Textbox (era el retraso de ~1s al esconder iniciales y archivo). */
    new MutationObserver(hideTextbox).observe(document.body, {
      attributes: true,
      attributeFilter: ['data-emb-none']
    });
  }
})();